// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/xstate-solid-bridge/solid.tmpl.ts
// Parameters       : infra/fleet/registry/repos.ts  (entry "tendly-app")
// Destination      : packages/fleet/state-machines/src/solid.ts
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo tendly-app
//     node fleet/fleet.ts check --repo tendly-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import {
  type Accessor,
  createEffect,
  createMemo,
  createSignal,
  onCleanup,
  onMount,
} from "solid-js";
import {
  type Actor,
  type AnyActorLogic,
  type AnyActorRef,
  createActor,
  type SnapshotFrom,
} from "xstate";

/**
 * Local reactive binding for XState actor refs under SolidJS.
 *
 * Replaces `@xstate/solid` (unmaintained, peer-pinned to Solid 1.x) with a clean,
 * unpinned reactive signal wrapper around XState actors.
 */
export function fromActorRef<TActor extends AnyActorRef | undefined>(
  actorRef: Accessor<TActor> | TActor,
): Accessor<SnapshotFrom<NonNullable<TActor>> | (undefined extends TActor ? undefined : never)>;

export function fromActorRef(
  ref: Accessor<AnyActorRef | undefined> | (AnyActorRef | undefined),
): Accessor<unknown> {
  const actor = createMemo(() => (typeof ref === "function" ? ref() : ref));
  const [snap, setSnap] = createSignal(actor()?.getSnapshot(), { equals: false });

  createEffect((isInitial?: boolean) => {
    const a = actor();
    if (!isInitial && a) {
      setSnap(a.getSnapshot());
    }
    if (a) {
      const subscription = a.subscribe({
        next: (nextSnapshot: unknown) => {
          setSnap(nextSnapshot);
        },
        error: () => {},
        complete: () => {},
      });
      onCleanup(() => subscription.unsubscribe());
    }
    return false;
  }, true);

  return snap;
}

export function useActorRef<TLogic extends AnyActorLogic>(
  ...args: Parameters<typeof createActor<TLogic>>
): Actor<TLogic> {
  const actorRef = createActor(...args);
  onMount(() => {
    actorRef.start();
  });
  onCleanup(() => {
    actorRef.stop();
  });
  return actorRef;
}
